import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_BUSINESS_CREATION = "SET_BUSINESS_CREATION";
export const UPDATE_BUSINESS_CREATION = "UPDATE_BUSINESS_CREATION";
export const SET_USER_BUSINESS_CREATION_REQUESTS =
  "SET_USER_BUSINESS_CREATION_REQUESTS";
export const SET_DOMICILIATION = "SET_DOMICILIATION";
export const UPDATE_DOMICILIATION = "UPDATE_DOMICILIATION";
export const SET_MANAGEMENT = "SET_MANAGEMENT";
export const SET_ODOO = "SET_ODOO";
export const UPDATE_MANAGEMENT = "UPDATE_MANAGEMENT";
export const UPDATE_ODOO = "UPDATE_ODOO ";
export const SET_JURIDIQUE = "SET_JURIDIQUE";
export const UPDATE_JURIDIQUE = "UPDATE_JURIDIQUE";
export const SET_GRH = "SET_GRH";
export const UPDATE_GRH = "UPDATE_GRH";
export const SET_ADMIN = "SET_ADMIN";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const SET_SALES = "SET_SALES";
export const UPDATE_SALES = "UPDATE_SALES";
export const SET_USER_MANAGEMENT_REQUESTS = "SET_USER_MANAGEMENT_REQUESTS";
export const SET_USER_ODOO_REQUESTS = "SET_USER_SALES_REQUESTS";

export const SET_USER_SALES_REQUESTS = "SET_USER_SALES_REQUESTS";

export const CLEAR_REQUEST = "CLEAR_REQUEST";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

function setCreationRequest(businessRequest) {
  return {
    type: SET_BUSINESS_CREATION,
    payload: businessRequest,
  };
}

function setManagementRequest(managementRequest) {
  return {
    type: SET_MANAGEMENT,
    payload: managementRequest,
  };
}

export const clearRequest = () => {
  return {
    type: CLEAR_REQUEST,
  };
};

function setDomiciliationRequest(domiciliationRequest) {
  return {
    type: SET_DOMICILIATION,
    payload: domiciliationRequest,
  };
}

function setJuridiqueRequest(juridiqueRequest) {
  return {
    type: SET_JURIDIQUE,
    payload: juridiqueRequest,
  };
}

function setOdooRequest(odooRequest) {
  return {
    type: SET_ODOO,
    payload: odooRequest,
  };
}

function setSalesRequest(salesRequest) {
  return {
    type: SET_SALES,
    payload: salesRequest,
  };
}

function setGrhRequest(grhRequest) {
  return {
    type: SET_GRH,
    payload: grhRequest,
  };
}

function setAdminRequest(adminRequest) {
  return {
    type: SET_ADMIN,
    payload: adminRequest,
  };
}

export function updateBusinessCreation(businessRequest) {
  return {
    type: UPDATE_BUSINESS_CREATION,
    payload: businessRequest,
  };
}

export function updateDomiciliation(domiciliationRequest) {
  return {
    type: UPDATE_DOMICILIATION,
    payload: domiciliationRequest,
  };
}

export function updateManagement(managementRequest) {
  return {
    type: UPDATE_MANAGEMENT,
    payload: managementRequest,
  };
}

export function updateOdoo(odooRequest) {
  return {
    type: UPDATE_ODOO,
    payload: odooRequest,
  };
}
export function updateJuridique(juridiqueRequest) {
  return {
    type: UPDATE_JURIDIQUE,
    payload: juridiqueRequest,
  };
}
export function updateGrh(grhRequest) {
  return {
    type: UPDATE_GRH,
    payload: grhRequest,
  };
}
export function updateSales(salesRequest) {
  return {
    type: UPDATE_SALES,
    payload: salesRequest,
  };
}
export function updateAdmin(adminRequest) {
  return {
    type: UPDATE_ADMIN,
    payload: adminRequest,
  };
}

export function setUserBusinessCreationrequests(userBusinessCreationRequests) {
  return {
    type: SET_USER_BUSINESS_CREATION_REQUESTS,
    payload: userBusinessCreationRequests,
  };
}

function setUserManagementRequests(userManagementRequest) {
  return {
    type: SET_USER_MANAGEMENT_REQUESTS,
    payload: userManagementRequest,
  };
}

function setUserOdooRequests(userOdooRequest) {
  return {
    type: SET_USER_ODOO_REQUESTS,
    payload: userOdooRequest,
  };
}

function setUserSalesRequests(userSalesRequest) {
  return {
    type: SET_USER_SALES_REQUESTS,
    payload: userSalesRequest,
  };
}

export function createBusinessRequest(token, businessData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/registration`,
        businessData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setCreationRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateBusinessRequest(
  token,
  reference,
  businessData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/registration/${reference}`,
        businessData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateBusinessCreation(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function fetchUserBusinessCreationRequests(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests/registration`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setUserBusinessCreationrequests(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function domiciliationRequest(token, domiciliationData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/domiciliations`,
        domiciliationData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(setDomiciliationRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateDomiciliationRequest(
  token,
  reference,
  businessData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/domiciliations/${reference}`,
        businessData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateDomiciliation(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function managementRequest(token, managementData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/managements`,
        managementData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setManagementRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function fetchManagementRequests(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests/managements`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setUserManagementRequests(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function updateManagementRequest(
  token,
  reference,
  managementData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/managements/${reference}`,
        managementData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateManagement(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function OdooRequest(token, odooData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/requests/odoo`, odooData, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setOdooRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function fetchOdooRequests(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests/odoo`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setUserOdooRequests(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function updateOdooRequest(token, reference, odooData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/odoo/${reference}`,
        odooData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateOdoo(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function juridiqueRequest(token, juridiqueData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/juridique`,
        juridiqueData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setJuridiqueRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateJuridiqueRequest(
  token,
  reference,
  juridiqueData,
  callback
) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/juridique/${reference}`,
        juridiqueData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateJuridique(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function grhRequest(token, grhData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/requests/grh`, grhData, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setGrhRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateGrhRequest(token, reference, grhData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/grh/${reference}`,
        grhData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateGrh(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function salesRequest(token, salesData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/sales`,
        salesData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setSalesRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function fetchSalesRequests(token) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests/sales`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setUserSalesRequests(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function updateSalesRequest(token, reference, grhData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/sales/${reference}`,
        grhData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateSales(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function adminRequest(token, adminData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/admin`,
        adminData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setAdminRequest(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateAdminRequest(token, reference, grhData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.put(
        `${HOST_URL}/requests/admin/${reference}`,
        grhData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await dispatch(updateAdmin(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

// Regions of a country, each flagged open or not to company creation
export function getCreationRegions(country, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/requests/registration/regions?country=${country}`,
        { headers },
      );
      callback(response.data.data || []);
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
      callback([]);
    }
  };
}
